import { Helmet } from 'react-helmet-async';

const SITE_URL  = 'https://www.prasilabs.com';
const SITE_NAME = 'PRASI LABS';
const DEFAULT_IMG = `${SITE_URL}/prasilabs-logo.png`;

/**
 * Drop-in SEO component — sets <title>, meta, OG, Twitter Card, canonical, JSON-LD.
 *
 * Usage:
 *   <SEO
 *     title="Drug Impurity Standards"
 *     description="Browse certified..."
 *     canonical="/catalog"
 *     keywords="impurity standards, ..."
 *     jsonLd={[...]}        // array of JSON-LD objects
 *   />
 */
export default function SEO({ title, description, keywords, canonical, ogImage, ogType = 'website', jsonLd }) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} — Pharmaceutical Reference Standards & Drug Impurities Supplier`;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : null;
  const image = ogImage || DEFAULT_IMG;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords    && <meta name="keywords"    content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:title"       content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type"        content={ogType} />
      <meta property="og:image"       content={image} />
      <meta property="og:site_name"   content={SITE_NAME} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter Card */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image"       content={image} />

      {/* JSON-LD blocks */}
      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
